$(function() {
    if (window.self !== window.top || !window.tinymce) {
        return;
    }

    tinymce.PluginManager.add('emoticons_yoda', function(ed, url) {
        var $temp = $('<div />');
        var mapping = [ '5', '6', '1', '4', '3', '9', '8', '2', '7' ];

        // setting the initial template
        $temp.html('<div class="emoticons-picker-wrap">\
            <div class="emoticons-picker-backdrop"></div>\
            <div class="emoticons-picker">\
                <div class="emoticons-holder"></div>\
                <nav class="category-picker">\
                    <a class="cat-1 active" href="#"></a>\
                    <a class="cat-2" href="#"></a>\
                    <a class="cat-3" href="#"></a>\
                    <a class="cat-4" href="#"></a>\
                    <a class="cat-5" href="#"></a>\
                    <a class="cat-6" href="#"></a>\
                    <a class="cat-7" href="#"></a>\
                    <a class="cat-8" href="#"></a>\
                    <a class="cat-9" href="#"></a>\
                </nav>\
                <a href="#" class="emoticons-close"><span></span></a>\
                <h3 class="emoticons-title">' + pageData.localisation.insert_emoticon + '</h3>\
            </div>\
        </div>');

        ed.addButton('emoticons_yoda', {
            title : 'emoticons.desc',
            type  : 'panelbutton',
            image : '',
            panel : {
                classes: 'lia-emoticons-panel',
                html: $temp.html(),
                onshow: function() {
                    // showing and hiding categories
                    var $div = $('<div />').html(window.emoticons_html);

                    $div.find('.EmoticonView li').each(function (i) {
                        var method = i != 2 ? 'hide' : 'show';
                        $(this).attr('data-cat', 'cat-' + mapping[i])[method]();
                    });

                    $('.emoticons-holder').html($div.html());

                    common.els.$body.header('toggleBodyOverflow', true);
                },
                onhide: function() {
                    common.els.$body.header('toggleBodyOverflow', false);
                },
                onclick: function(e) {
                    var $target = $(e.target),
                        $parent = $target.parent();

                    if ($target.hasClass('emoticons-close') || $parent.hasClass('emoticons-close')) {
                        this.hide();
                        return;
                    }

                    var classname = $target.attr('class');

                    if (classname && classname.indexOf('cat-') >= 0 && !$target.hasClass('active')) {
                        var $emo = $('.EmoticonView');
                        var $li = $emo.find('li[data-cat="cat-' + ( $target.index() + 1 ) + '"]');

                        $emo.scrollTop(0);
                        $li.show().siblings().hide();
                        $target.addClass('active').siblings().removeClass('active');

                        return;
                    }

                    if ($target.hasClass('emoticon-link') || $parent.hasClass('emoticon-link')) {
                        var content = $target.attr('alt');
                        if (!content) {
                            content = $target.children().attr('alt');
                        }

                        ed.insertContent(content);
                        this.hide();
                        return;
                    }

                    return;
                }
            }
        });
    });
});
